import {
    graphql
} from 'react-relay'


const query = graphql`
    query getAllProfessionQuery ($pagination: PaginationInput, $sorts: [OrderInput!], $where: JSON) {
        getAllProfession (pagination: $pagination, sorts: $sorts, where: $where) {
            count,
            items {
                id
                name
                createdAt
                updatedAt
            }
      }
    }
  `

  export default query;